import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import * as pluralize from "pluralize";
import {DeviceAvdbSeries} from "../device-avdb-series";
import {DeviceAvdbType} from "../device-avdb-type";
import {CoverageDetailComponent} from "../shared/coverage-detail.component";
import {IgnoreDatabaseComponent} from "../shared/ignore-database.component";
import {DeviceService} from "../device.service";
import {AvdbTypeRowStatus} from "./avdb-type-row-status";

@Component({
	selector: "avdb-type-row",
	template: `
		<div *ngIf="typeRowStatus" class="deviceproductrow">

			<div class="deviceproductrow_statusicon">
				<i class="deviceproductrow_icon {{typeRowStatus.statusColor}} {{typeRowStatus.statusIcon}}"></i>
			</div>

			<div class="deviceproductrow_content">

				<!-- If the current device is part of a master aircraft, we want to break the install status down by region -->
                <avdb-type-row-v2 *ngIf="isMasterAircraft"
                                  [avdbType]="avdbType"
                                  [deviceService]="deviceService"
                                  [coverageModal]="coverageModal"
                                  [ignoreDatabaseModal]="ignoreDatabaseModal"
                                  [showJeppesenLogin]="showJeppesenLogin"
                                  [otherInstallableSeries]="otherInstallableSeries">
				</avdb-type-row-v2>

				<!-- If the current device is not part of a master aircraft, we do not want to break the install status down by region -->
                <avdb-type-row-v1 *ngIf="!isMasterAircraft"
								  [avdbType]="avdbType"
								  [deviceService]="deviceService"
								  [coverageModal]="coverageModal"
								  [ignoreDatabaseModal]="ignoreDatabaseModal"
								  [otherInstallableSeries]="otherInstallableSeries"
								  [otherIssuesHeading]="otherIssuesHeading">
				</avdb-type-row-v1>

				<div class="deviceproductrow_warnings">
					<!-- TODO: WARNINGS HERE -->
				</div>

			</div>

		</div>
	`,
})
export class AvdbTypeRowComponent implements OnInit {
	@Input() avdbType: DeviceAvdbType;
	@Input() deviceService: DeviceService;
	@Input() coverageModal: CoverageDetailComponent;
	@Input() ignoreDatabaseModal: IgnoreDatabaseComponent;
	@Input() isConnectedCockpitAircraft: boolean;
	@Input() showJeppesenLogin: boolean;
	@Input() isMasterAircraft: boolean;
	@Output() jeppesenLoginButtonClicked = new EventEmitter();

	otherInstallableSeries: Array<DeviceAvdbSeries>;
	typeRowStatus: AvdbTypeRowStatus;

	ngOnInit() {
		this.typeRowStatus = new AvdbTypeRowStatus(this.avdbType, null, this.avdbType.status);
		if (this.isMasterAircraft) {
			this.otherInstallableSeries = this.avdbType.installableSeries
				.filter(avdbSeries => !this.avdbType.isAnInstalledSeries(avdbSeries.id));
		} else {
			this.otherInstallableSeries = this.avdbType.installableSeries
				.filter(avdbSeries => !this.avdbType.isInstalledSeries(avdbSeries.id));
		}
	}

	get otherIssuesHeading() {
		if (this.avdbType.installedIssue)
			return pluralize(this.otherInstallableSeries.length, [
				"1 other database",
				"# other databases",
			]);
		else
			return "Ready to install";
	}
}
